module Eseebase {

    export class CorrectionViewModel {
        id: string;
        apartmentId: string;
        companyNumber: string;
        association: string;
        department: string;
        localizer: string;
        sheetNumber: string;
        fileName: string;
        url: string;
        status: string;
        createdByUserId: string;
        createdByEmail: string;
        modifiedByUserId: string;
        canEdit: boolean;
        isClosed: boolean;
        priority: string;
        fileId: string;
        correctionItems: CorrectionItemViewModel[];
        attachments: CorrectionAttachmentViewModel[];
        comments: CorrectionCommentsByDate[];
        newComments: CorrectionCommentViewModel[];
        images: CorrectionImageViewModel[];
        constructor() {
            this.correctionItems = [];
            this.attachments = [];
            this.comments = [];
            this.images = [];
        }
    }

    export class CorrectionImageViewModel {
        id: string;
        correctionId: string;
        constructor(public url: string) { }
    }

    export class CorrectionItemViewModel {
        id: string;
        correctionType: CorrectionType;
        text: string;
        locationX: number;
        locationY: number;
        width: number;
        height: number;
        rotationAngle: number;
        active: boolean;
        correctionId: string;
        isMoving: boolean;
        static icons = ['&#xe909;', '&#xe908;', '&#xe915;', '&#xe900;', '&#xe914;', '&#xe910;', '&#xe911;'];
    }

    export class CorrectionAttachmentViewModel {
        id: string;
        fileName: string;
        url: string;
    }

    export class CorrectionCommentViewModel {
        id: string;
        correctionId: string;
        userId: string;
        userName: string;
        commentDate: Date;
        text: string;
    } 

    export class CorrectionCommentsByDate {
        dateAsString: string;
        comments: CorrectionCommentViewModel[];
        constructor() {
            this.comments = [];
        }
    }


    export enum CorrectionType {
        move = 0,
        flip,
        rotate,
        delete,
        edit,
        warning,
        comment,
        arrow
    }
}